import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import { useTranslation } from "@/packages/utils";

interface AuditStatusConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  actionLabel: string;
  targetStatusLabel: string;
  isPending: boolean;
}

export function AuditStatusConfirmModal({
  open,
  onClose,
  onConfirm,
  actionLabel,
  targetStatusLabel,
  isPending,
}: AuditStatusConfirmModalProps) {
  const { t } = useTranslation("audits");

  return (
    <ConfirmDialog open={open} onClose={onClose}>
      <ConfirmDialog.Title>
        {t("statusConfirm.title", { action: actionLabel })}
      </ConfirmDialog.Title>
      <ConfirmDialog.Body>
        <p className="text-sm text-secondary">
          {t("statusConfirm.body")}{" "}
          <span className="font-medium text-primary">{targetStatusLabel}</span>?
        </p>
      </ConfirmDialog.Body>
      <ConfirmDialog.Actions
        onConfirm={onConfirm}
        confirmLabel={actionLabel}
        loading={isPending}
      />
    </ConfirmDialog>
  );
}
